var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{class:{
      disabled: _vm.disabled,
      btn: true,
      'btn-light': true,
      'btn-sm': true,
    },attrs:{"title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.clickHandler.apply(null, arguments)},"mouseover":function($event){$event.stopPropagation();_vm.isHovering = true},"mouseout":function($event){$event.stopPropagation();_vm.isHovering = false}}},[_c('Icon',{attrs:{"clickHandler":_vm.clickHandler,"height":_vm.height,"title":_vm.title,"viewBox":_vm.viewBox,"path":_vm.path,"disabled":_vm.disabled}}),(_vm.text?.length > 0)?_c('span',{staticClass:"btn-txt"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }